import { render, staticRenderFns } from "./submittedSuccessfully.vue?vue&type=template&id=4ad6c460&scoped=true"
import script from "./submittedSuccessfully.vue?vue&type=script&lang=js"
export * from "./submittedSuccessfully.vue?vue&type=script&lang=js"
import style0 from "./submittedSuccessfully.vue?vue&type=style&index=0&id=4ad6c460&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad6c460",
  null
  
)

export default component.exports